// extracted by mini-css-extract-plugin
export default {"reportsPage":"ContractReportPage_reportsPage__EoR-b"};